import React from 'react';
import { useSnackbar } from '@components/Provider';

interface Props {
  id: string;
  accept?: string;
  uploadBtn: React.ReactNode;
  multiple: boolean;
  maxSize: number;
  disabled?: boolean;
  onChange: (files: Array<File>) => void;
}
const UploadPresenter = React.forwardRef((props: Props, ref: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const maxSize = props.maxSize! * 1024 * 1024;

  const accept = (prop: string) => {
    const extension = prop.split(', ');
    const newAccept = [
      ...extension.map((accept) => accept.toUpperCase()),
      ...extension.map((accept) => accept.toLocaleLowerCase())
    ].join(',');
    return newAccept;
  };

  return (
    <div className="btn-wrapper">
      <input
        ref={ref}
        accept={props.accept}
        type="file"
        id={props.id}
        style={{ display: 'none' }}
        multiple={props.multiple}
        disabled={props.disabled}
        onClick={(e) => {
          e.stopPropagation();
          const element = e.target as HTMLInputElement;
          element.value = '';
        }}
        onChange={(e) => {
          e.stopPropagation();
          e.preventDefault();
          if (e.target.files) {
            const fileList = e.target.files;
            let result: Array<File> = [];
            for (let i = 0; i < fileList.length; i++) {
              const file = fileList.item(i);
              if (!file) {
                enqueueSnackbar('파일 업로드를 실패하였습니다.', {
                  variant: 'error'
                });
                continue;
              }
              if (file.size > maxSize) {
                enqueueSnackbar(`파일 크기를 초과하였습니다.(${file.name})`, {
                  variant: 'error'
                });
                continue;
              }
              const fileExtension = file.name.slice(
                file.name.lastIndexOf('.') + 1
              );
              if (
                props.accept &&
                accept(props.accept).indexOf(fileExtension) === -1
              ) {
                enqueueSnackbar('2D도면 파일(DWG, DXF)만 업로드 가능합니다.', {
                  variant: 'error'
                });
                continue;
              }
              result = result.concat(file);
            }
            props.onChange(result);
          }
        }}
      />
      <label htmlFor={props.id}>{props.uploadBtn}</label>
    </div>
  );
});

export default UploadPresenter;
